<template>
  <v-app>
    <component :is="currentHeaderComponent"></component>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import CompanyHeader from './components/Header/CompanyHeader.vue';

export default {
  name: 'App',
  components: {
    CompanyHeader
  },
  computed: {
    currentHeaderComponent() {
      // Use the header component specified in the route meta, default to AppHeader
      return this.$route.meta.headerComponent || CompanyHeader;
    }
  }
}
</script>
